export default "__VITE_PUBLIC_ASSET__5453a640__"